module.exports = __webpack_public_path__ + "static/media/foto2.c0da2414.png";